module.exports = __webpack_public_path__ + "static/media/Home.9957f9c0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/bg/Home.mp4
// module id = 834
// module chunks = 0